import {
  CopyIcon,
  EllipsisVerticalIcon,
  PlayIcon,
} from "assets";
import { CustomTooltip } from "components";
import { forwardRef, useState } from "react";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";
import { VideoEpisodeProps } from "../../store/actionType";

interface OwnProps {
  clickedFolder: React.MouseEventHandler<HTMLDivElement> | undefined;
  clickedMenu: React.MouseEventHandler<HTMLButtonElement> | undefined;
  children: React.ReactNode;
  episodeData: VideoEpisodeProps;
}
type Props =  OwnProps;
const EpisodeFolderCard = forwardRef<HTMLDivElement, Props>(
  (
    {
      clickedFolder,
      clickedMenu,
      children,
      episodeData,
    },
    ref
  ) => {
    const [copied, setCopied] = useState(false);
    const [showTooltip, setShowTooltip] = useState(true);
    const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      const success = await copyToClipboard(
        episodeData?.video?.identifier?? ""
      );
      if (success) {
        setCopied(true);
        setShowTooltip(false);
        setTimeout(() => {
          setCopied(false);
          setShowTooltip(true);
        }, 1500);
      }
    };
    return (
      <div
        ref={ref}
        className="bg-white border border-primary-300 rounded-md cursor-pointer p-2 hover:border-primary-500 hover:shadow-md relative"
        onClick={clickedFolder}
      >
        <div className="relative w-full h-[10vh] bg-primary-50 flex justify-center items-center">
          <PlayIcon />
          <div className="absolute top-0 right-0">
            <CustomTooltip title={`Edit ${episodeData.label}`} placement="bottom">
              <button
                onClick={clickedMenu}
                className="text-primary-400 hover:text-gray-700 p-1 hover:rounded-full hover:bg-primary-100"
              >
                <EllipsisVerticalIcon />
              </button>
            </CustomTooltip>
          </div>
          <div className="absolute flex items-center -top-2 left-2">
            <h3 className=" font-medium text-gray-900">{episodeData.label}</h3>
            <p className="text-xs text-gray-600 ml-[2px]">{episodeData.episode_number}</p>
          </div>
          <div className="absolute right-0 top-8 mt-2 bg-white border border-gray-200 rounded-md shadow-md z-10">
            {children}
          </div>
        </div>
        {!episodeData.video ? (
          <div className="flex flex-col justify-center items-center py-3 text-gray-500 text-sm">
            <p>No Video data</p>
            <p>Add Video Details</p>
          </div>
        ) : (
          <div>
            <h1 className="font-bold">
              {episodeData?.video?.title}
            </h1>
            <p className="text-[12px] font-bold">
              Episode: {episodeData.label}
              {episodeData.episode_number}
            </p>
            <p className="relative text-[12px] flex items-center">
              ID: <span className="text-primary-700">{episodeData?.video?.identifier}</span>{" "}
              <CustomTooltip title={showTooltip ? "Copy video id" : ""} placement="right">
                <button onClick={handleCopy} className="p-1">
                  <CopyIcon className="size-4 ml-2" />
                </button>
              </CustomTooltip>
              {copied && (
                <div className="absolute top-0 right-2 bg-green-500 text-white px-3 py-1 rounded shadow-md text-sm animate-fadeInOut z-30">
                  ID Copied!
                </div>
              )}
            </p>
            <p className="text-[12px]">
              visibility: {episodeData?.video?.visibility}
            </p>
          </div>
        )}
      </div>
    );
  }
);
export default EpisodeFolderCard;
